import React, { Component } from 'react';
import style from './topbar.less';
import Progressbar from './progressbar.jsx';

export default class Topbar extends Component {
    render() {
        const { pageList, currentPageIndex, lastPageIndex, fields, errorText } = this.props;
        const props = { pageList, currentPageIndex, lastPageIndex, fields, errorText };
        return (
            <aside tabIndex="-1" className={style.topbar}>
                <div className={style.topbar__wrapper}>
                    <div className={style.topbar__savingIndicator}></div>
                    <Progressbar {...props} />
                </div>
            </aside>
        );
    }
}
